
const commission = [
  {
    'name': 'organization',
    'commission': {
      'credit': 0,
      'debit': 0,
      'transfert': 0,
      'transfertCollect': 0,
      'depotCollect': 0
    }
  },
  {
    'name': 'parrain',
    'commission': {
      'credit': 0,
      'debit': 0,
      'transfert': 0,
      'transfertCollect': 0,
      'depotCollect': 0
    }
  },
  {
    'name': 'clk',
    'commission': {
      'credit': 100,
      'debit': 100,
      'transfert': 100,
      'transfertCollect': 100,
      'depotCollect': 100
    }
  }
];

const refund = [
  {
    'name': 'organization',
    'commission': {
      'credit': 0,
      'debit': 0,
      'transfert': 0,
      'transfertCollect': 0,
      'depotCollect': 0
    }
  },
  {
    'name': 'parrain',
    'commission': {
      'credit': 100,
      'debit': 100,
      'transfert': 100,
      'transfertCollect': 100,
      'depotCollect': 100
    }
  }
];


const timeOpenClose = [
  {
    'day': 'MONDAY',
    'timeOpenClose': {
      'openHour': null,
      'closeHour': null,
      'active': true
    }
  },
  {
    'day': 'TUESDAY',
    'timeOpenClose': {
      'openHour': null,
      'closeHour': null,
      'active': true
    }
  },
  {
    'day': 'WEDNESDAY',
    'timeOpenClose': {
      'openHour': null,
      'closeHour': null,
      'active': true
    }
  },
  {
    'day': 'THURSDAY',
    'timeOpenClose': {
      'openHour': null,
      'closeHour': null,
      'active': true
    }
  },
  {
    'day': 'FRIDAY',
    'timeOpenClose': {
      'openHour': null,
      'closeHour': null,
      'active': true
    }
  },
  {
    'day': 'SATURDAY',
    'timeOpenClose': {
      'openHour': null,
      'closeHour': null,
      'active': true
    }
  },
  {
    'day': 'SUNDAY',
    'timeOpenClose': {
      'openHour': null,
      'closeHour': null,
      'active': true
    }
  }
];

const organizationConfig = {
  connectionDelay: 1,
  activatePartnerDoubleAuthenticator: false,
  timeOpenClose: timeOpenClose,
  useApi: false,
  apiKey: null,
  apiSecret: null,
  externalAccessRole:null,
  dfaNotificationType:null,
  provider: false
}

export class Organization {
  reference: string;
  name: string;
  address: string;
  email: string;
  phone: string;
  type: string;
  country: any;
  rccm: string;
  ifu: string;
  authorizedIps: string;
  parent: any;
  manager: any;
  media: any;
  commission: any = commission;
  // tpoCommission: TPOCommission[];
  refund: any = refund;
  status: string;
  depositAccount: any;
  organizationConfig: any = organizationConfig;
}


export class TPOCommission{
  operation:string;
  clk:number;
  parrain:number;
  organization:number;
}


// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/organization/organization.model.ts